import { Button } from "~/components/atoms/Button";

export function ErrorContent({ title, description }: { title: string; description: string }) {
    return (
        <div className="h-full min-h-60 flex-col content-center bg-blue-10 text-center">
            <div className="gap-2">
                <h1 className="font-header-xs text-gray-80">{title}</h1>
                <p className="font-body">{description}</p>
            </div>
            <div className="my-4">
                <a href="https://plus.imgacademy.com" aria-label="return to home page">
                    <Button>Go to Home Page</Button>
                </a>
            </div>
        </div>
    );
}
